module.exports = __webpack_public_path__ + "resources/img/img_vehicle_process_m.9b5fcc79e3ce90d54efb0cc3a9b18a97.png";